import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article9Doc } from '../individual';

export default function Article9() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <Article9Doc />
        <Footer />
    </div>
  )
}
